export * from './PaymentError';
export * from './PaymentSuccess';
export * from './PaymentWait';
export * from './PaymentTitle';
export * from './PaymentGoBackButton';
